import { useMutation, useQueryClient } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { DisabledScheduleMutationContextType } from "./Common";
import { keys } from "./Keys";

export type EnableObjectSetpointsParameters = {
    groupID: number,
    objectType: eLynxObjectTypeEnum;
    objectID: number;
} & BaseUseMutationParameters<void, void>;

export function useEnableObjectSetpoints({
    groupID,
    objectType,
    objectID,
    onError,
    onSuccess
}: EnableObjectSetpointsParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, void, DisabledScheduleMutationContextType>(
        () => {
            return AlarmSetpointsDataService.enableObjectSetPoints(
                groupID,
                objectType,
                objectID
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _item, context) => {
                queryClient.invalidateQueries(keys.disableSchedules());
                queryClient.invalidateQueries(keys.lists());
            }
        }
    );
}
